import { Box } from '@mui/material';
import React from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectAssistCard } from '../../redux/features/assistRequest/assistRequest.selectors';
import { IAssistBodyProps } from './assistBody.types';
import AssistRequestCard from './AssistRequestCard';

interface Props {
  onAnswer: IAssistBodyProps['onAnswer'];
}

/**
 * HITL-1773 (HITL 8.0.0): the assist pool on the task-router lobby — the card
 * task-router assigned this agent, as the first tile of the lobby grid; the
 * issue backlog is the grid's last tile (`TaskRouterPage`).
 *
 * Renders nothing without a card, so a lobby with no requests is laid out
 * exactly as before. Mouse only: the card answers by click.
 */
const AssistPoolPanel = ({ onAnswer }: Props) => {
  const card = useAppSelector(selectAssistCard);
  if (!card) return null;

  return (
    <Box
      role="region"
      aria-label="Assist requests"
      data-testid="assist-pool-panel"
      sx={{
        // Its card is a tile of the lobby grid (`TaskRouterPage`), not a
        // column of its own.
        display: 'contents',
      }}
    >
      <AssistRequestCard
        // A new assignment is a new card: per-card state in the body must not
        // carry over from the previous one.
        key={card.requestId}
        card={card}
        onAnswer={onAnswer}
      />
    </Box>
  );
};

export default AssistPoolPanel;
